import React from 'react';

const RejectionDetails = ({ rejectionReasonDetail, rejectionDetails }) => {
  if (!rejectionReasonDetail) return null;

  const reason = rejectionReasonDetail;

  return (
    <div className="rejection-details">
      <div className="rejection-header">
        <h4>Rejection Details</h4>
        <span className={`severity-badge severity-${reason.severity.toLowerCase()}`}>
          {reason.severity}
        </span>
      </div>
      
      <div className="rejection-info">
        <div className="info-row">
          <label>Reason:</label>
          <span>{reason.title}</span>
        </div>
        <div className="info-row">
          <label>Category:</label>
          <span>{reason.category}</span>
        </div>
        <div className="info-row">
          <label>Description:</label>
          <span>{reason.description}</span>
        </div>
      </div>
      
      {reason.resolutionSteps && reason.resolutionSteps.length > 0 && (
        <div className="resolution-steps">
          <h5>Resolution Steps:</h5>
          <ol>
            {reason.resolutionSteps.map((step, index) => (
              <li key={index}>{step}</li>
            ))}
          </ol>
        </div>
      )}
      
      {reason.businessImpact && (
        <div className="business-impact">
          <h5>Business Impact:</h5>
          <p>{reason.businessImpact}</p>
        </div>
      )}
      
      {rejectionDetails && Object.keys(rejectionDetails).length > 0 && (
        <div className="additional-details">
          <h5>Additional Details:</h5>
          <pre>{JSON.stringify(rejectionDetails, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};

export default RejectionDetails;
